module.exports = __webpack_public_path__ + "static/media/N.5415372d.png";